import { Component, Input } from '@angular/core';

// TODO: Why do we not have "pi-modal" class on this?
@Component({
    selector: 'modal',
    template: `
        <div class="modal show" tabindex="-1" role="dialog">
            <div role="document" class="modal-dialog" [ngClass]="getClass()">
                <div class="modal-content pi-modalContent">
                    <ng-content></ng-content>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <div class="modal-backdrop fade in"></div>
    `,
    standalone: false
})
export class ModalComponent {
    @Input()
    options: {
        dialogClass?: string;
    };

    getClass() {
        return this.options ? this.options.dialogClass : '';
    }
}
